export default __webpack_public_path__ + "static/media/cart_3d.ebb4e811.png";